import request from "superagent";
import Promise from "bluebird";
import md5 from "blueimp-md5";
import parseUrl from "locutus/php/url/parse_url";

Promise.config({
  cancellation: true, // this is for cancelling running xhr
  warnings: __DEV__
});

// eslint-disable-next-line prefer-destructuring
const Request = request.Request;

/**
 * add base url
 *
 * this removes having to add the base url in every api request
 *
 * i.e. /someResource => /api/someResource
 *
 * or if it starts with http then just let it be
 *
 * i.e. http://external
 *
 * @todo move api to separate request (i.e. api.js)
 */
Request.prototype.addBaseUrl = function addBaseUrl() {
  if (this.url.indexOf("http") === 0) {
    return this;
  }
  // add base url.. means you can call this as "/resourceX" or "resourceX"
  this.url = `/gateway/api/${this.url.replace(/^\//, "")}`;
  return this;
};

/**
 *
 */
Request.prototype.noCache = function noCache() {
  if (!this.url.startsWith("http")) {
    this.set("Cache-Control", "no-cache");
  }
  return this;
};

const cashierCache = {};

const getCashierHash = req => {
  const data = {
    method: req.method,
    url: req.url,
    query: req._query,
    data: req._data
  };
  if (data.method === "GET" && data.url.indexOf("?") !== -1) {
    const _url = parseUrl(req.url);
    data.url = _url.path;
    data.query = [_url.query];
  }
  const hash = JSON.stringify(data);
  return md5(hash);
};

// window.md5 = md5;
/**
 * cashier
 */
Request.prototype.onCashier = function onCashier() {
  if (!this.isCashier) {
    return this;
  }
  const body = cashierCache[getCashierHash(this)];
  if (!body) {
    return this;
  }

  // reset the _end to the original _end (if available)
  // this ensures we can return `this` to get standard functionality
  if (this._org_end) {
    this._end = this._org_end;
  }

  // overload the _end to return the above response
  this._org_end = this._end;
  this._end = function _end() {
    if (window.console && window.console.info) {
      window.console.info("XHR cashier", this.method, this.url, body);
    }
    return this.callback(null, {
      status: 200,
      body
    });
  };
  return this;
};

/**
 *
 * @see https://github.com/KyleAMathews/superagent-bluebird-promise/blob/master/index.js
 *
 * Make superagent requests Promises/A+ conformant
 *
 * Call .then([onFulfilled], [onRejected]) to register callbacks
 *
 * @return {Promise}
 */

const queryCache = {};

Request.prototype.then = function then(handler, errorHandler) {
  if (!this.promise) {
    this.promise = Promise.resolve().then(params => {
      params = params || {};

      this.set("Accept", "application/json");
      this.query(params);
      this.addBaseUrl();
      this.onCashier();
      this.noCache();

      //   app:websocket new connection +5s 20990387
      const promise = new Promise((resolve, reject, onCancel) => {
        onCancel(() => {
          this.abort();
        });
        this.end((err, res) => {
          // handle 403 errors when sending a token (i.e. was logged in and token is now invalid)
          if (res && (res.status === 401 || res.status === 403)) {
            err = new Error(err.message);
            err.status = res.status;
            err.body = res.body;
            err.res = res;
            reject(err);
            return;
          }

          if (err) {
            err = new Error(err.message);
            err.status = res && res.status;
            err.body = res && res.body;
            err.res = res;
            reject(err);
            return;
          }

          if (res.status >= 400) {
            const msg = `Cannot ${this.method} ${this.url} (${this.status})`;
            err = new Error(msg);
            err.status = res.status;
            err.body = res.body;
            err.res = res;
            reject(err);
            return;
          }

          if (this.isCashier && res.body) {
            cashierCache[getCashierHash(this)] = res.body;
          }

          resolve(res.body);
        });
      });

      if (this.method !== "GET" && !this.lifo) {
        return promise;
      }

      const urlKey = this.url.replace(/\?.*$/, "");
      if (queryCache[urlKey]) {
        queryCache[urlKey].cancel();
      }

      queryCache[urlKey] = promise;

      return queryCache[urlKey];
    });
  }
  return this.promise.then(handler, errorHandler);
};

Request.prototype.token = function token(t) {
  this.set("X-API-TOKEN", t);
  return this;
};

/**
 * Last in first out cancels previous requests
 *
 * @returns {request.Request}
 */
Request.prototype.lifo = function lifo() {
  this.lifo = true;
  return this;
};

/**
 * Cache results based on input
 *
 * @returns {request.Request}
 */
Request.prototype.cashier = function cashier() {
  this.isCashier = true;
  return this;
};

export default request;
